import { Component, Input, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SingleFormControlCvaComponent } from 'shared';
import { ReactiveFormsModule } from '@angular/forms';
import { ApplyProvidedPipePipe } from 'design-system';

@Component({
  selector: 'tngh-checkbox',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ApplyProvidedPipePipe],
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent extends SingleFormControlCvaComponent {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  @Input() checkboxLabel: any = '';
  @Input() pipe?: PipeTransform = { transform: (value) => value };
  @Input() variant: 'admin' | 'tablet' = 'admin';
}
